import script from "./RouterLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouterLink.vue?vue&type=script&setup=true&lang=ts"

import "./RouterLink.vue?vue&type=style&index=0&id=35fcf14e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35fcf14e"]])

export default __exports__